import React from 'react'
import './style.scss'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()

import Button from '../buttons'
import FooterNav from '../footer-nav'

class Footer extends React.Component {
  render () {
    const footerClasses = [
      this.props.secondary && 'footer--secondary'
    ].join(' ')
    const data = this.props.data
    return (
      <footer className={`footer ${footerClasses}`} id='footer'>
        <div className='container'>
          <div className='footer-contentWrapper'>
            { this.props.primary ? <div>
              <h6 className='footer-subtitle'>{data.homeFooterTagLine}</h6>
              <div className='footer-logo'>
                <img src='/images/logo-color.svg' alt='b37 logo' />
              </div>
              <p className='footer-description' dangerouslySetInnerHTML={{__html: md.renderInline(data.homeFooterDescription)}} />
              <div className='u-marginBottomXxlarge u-marginBottomLarge--ipad'>
                <Button text={data.homeFooterButtonText} link='/about' />
              </div>
            </div> : '' }
            <h4 className='footer-inspirational' dangerouslySetInnerHTML={{__html: md.renderInline(data.footerCatchphrase)}} />
          </div>
          <FooterNav data={data.footerNav} />
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js